import { alpha } from '@mui/material/styles';

/** Hero typography on full-page gradients — dark upper bands need light text. */
export function getPageHeroTextColors(templateId, theme) {
  if (['medium', 'dark', 'aqua', 'orchid'].includes(templateId)) {
    return { primary: '#f8fafc', secondary: '#cbd5e1' };
  }
  return { primary: theme.textPrimary, secondary: theme.textSecondary };
}

/** Outlined button styles that always contrast with a panel/card theme slice. */
export function panelOutlinedButtonSx(theme) {
  return {
    textTransform: 'none',
    color: theme.textPrimary,
    borderColor: theme.panelBorder,
    '&:hover': {
      borderColor: theme.textPrimary,
      bgcolor: alpha(theme.textPrimary, 0.08)
    },
    '& .MuiButton-startIcon': { color: theme.textSecondary }
  };
}
